/**
 * Platform + tenant audit log API.
 * Retention is enforced server-side (90 days).
 */
import { get } from '@core/api/client';
import { endpoints } from '@core/api/endpoints';

export interface AuditEvent {
  id: string;
  actorUserId: string | null;
  /** Actor's email from the backend (any user, not only platform users). */
  actorEmail?: string | null;
  tenantId: string | null;
  action: string;
  resource: string;
  metadata: Record<string, unknown>;
  ip: string | null;
  createdAt: string;
}

export interface PaginatedAuditEvents {
  items: AuditEvent[];
  total: number;
  page: number;
  limit: number;
}

export interface ListAuditQuery {
  page?: number;
  limit?: number;
  action?: string;
  actorUserId?: string;
  from?: string;
  to?: string;
}

function toParams(query: ListAuditQuery): Record<string, string> {
  const params: Record<string, string> = {};
  if (query.page) params.page = String(query.page);
  if (query.limit) params.limit = String(query.limit);
  if (query.action?.trim()) params.action = query.action.trim();
  if (query.actorUserId?.trim()) params.actorUserId = query.actorUserId.trim();
  if (query.from) params.from = query.from;
  if (query.to) params.to = query.to;
  return params;
}

export const auditService = {
  listPlatform(query: ListAuditQuery = {}): Promise<PaginatedAuditEvents> {
    return get<PaginatedAuditEvents>(endpoints.platformAudit.list, {
      params: toParams(query),
    });
  },

  listTenant(query: ListAuditQuery = {}): Promise<PaginatedAuditEvents> {
    return get<PaginatedAuditEvents>(endpoints.tenantAudit.list, {
      params: toParams(query),
    });
  },
} as const;
